module.exports = __webpack_public_path__ + "img/bbshomepage5.4eb31a58.png";